var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.291 1.81766C5.79456 1.81766 2.95306 4.65915 2.95306 8.15556V11.2084C2.95306 11.8527 2.67842 12.8351 2.35096 13.3844L1.13619 15.4019C0.386209 16.6484 0.903805 18.0322 2.27702 18.4969C6.82975 20.018 11.7417 20.018 16.2944 18.4969C17.5725 18.0744 18.1324 16.5639 17.4352 15.4019L16.2204 13.3844C15.9035 12.8351 15.6289 11.8527 15.6289 11.2084V8.15556C15.6289 4.66971 12.7768 1.81766 9.291 1.81766Z",
    stroke: "#878787",
    strokeWidth: 1.5836,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2452 2.1232C10.9177 2.02813 10.5797 1.95419 10.2311 1.91193C9.21704 1.78517 8.24522 1.85912 7.33679 2.1232C7.64312 1.34152 8.40367 0.792236 9.29098 0.792236C10.1783 0.792236 10.9388 1.34152 11.2452 2.1232Z",
    stroke: "#878787",
    strokeWidth: 1.58448,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.46 18.8776C12.46 20.6205 11.0339 22.0465 9.291 22.0465C8.42482 22.0465 7.62202 21.6874 7.05163 21.117C6.48122 20.5465 6.12207 19.7437 6.12207 18.8776",
    stroke: "#878787",
    strokeWidth: 1.58448,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/BellIcon.babdcb83177eb69fae99e92eae411dfb.svg";
export { ForwardRef as ReactComponent };